import type { IconNode } from '../types';

/**
 * @name calendar-off
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTYgMnYzIiAvPgogIDxwYXRoIGQ9Im0yIDIgMjAgMjAiIC8+CiAgPHBhdGggZD0iTTIxIDloLTUuNSIgLz4KICA8cGF0aCBkPSJNMyA5aDYiIC8+CiAgPHBhdGggZD0iTTMuNTg2IDMuNTg2QTIgMiAwIDAwMyA1djE0YTIgMiAwIDAwMiAyaDE0YTIgMiAwIDAwMS40MTQtLjU4NiIgLz4KICA8cGF0aCBkPSJNOC42NTYgM0gxOWEyIDIgMCAwMTIgMnYxMC4zNDQiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/calendar-off
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const CalendarOff: IconNode = [
  ['path', { d: 'M16 2v3' }],
  ['path', { d: 'm2 2 20 20' }],
  ['path', { d: 'M21 9h-5.5' }],
  ['path', { d: 'M3 9h6' }],
  ['path', { d: 'M3.586 3.586A2 2 0 003 5v14a2 2 0 002 2h14a2 2 0 001.414-.586' }],
  ['path', { d: 'M8.656 3H19a2 2 0 012 2v10.344' }],
];

export default CalendarOff;
